<template>
  <div id="noti">
    <div class="notiBox">
      <transition-group name="list" tag="p">
        <div
          :class="['box', item.type]"
          v-for="item in array"
          :key="item.id"
          @mouseover="StopTimer(item.id)"
          @mouseleave="StartTimer(item.id)"
        >
          <i
            v-if="item.type == Enums.TypeComponentNoti.error || item.type == Enums.TypeComponentNoti.warn"
            class="fas fa-exclamation-circle alertNoti"
          ></i>
          <i v-if="item.type == Enums.TypeComponentNoti.success" class="fas fa-check-circle alertNoti"></i>
          <div v-if="item.type == Enums.TypeComponentNoti.upload" class="alertNoti">
            <img width="25" src="@/assets/img/uploading.gif" alt="" />
          </div>
          <i class="icon-close close" @click="remove(item.id)"></i>
          <p class="text-break">
            {{ item.message }} <span v-if="item.type === Enums.TypeComponentNoti.upload">{{ item.progress }}%</span>
          </p>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Enums from "../../enums/enums";
import i18n from "../../locales/i18n";
export default {
  computed: {
    getAlertMessage() {
      return this.$store.getters.GetAlertMessage;
    },
    getUserModel() {
      return this.$store.getters.getUserModel;
    },
  },
  data() {
    return {
      options: {},
      array: [],
      timer: {},
      errorMessage: "",
    };
  },
  watch: {
    getAlertMessage: {
      deep: true,
      handler() {
        this.options = this.getAlertMessage;
        this.$store.dispatch("ResetAlertMessage");
      },
    },
    options: {
      deep: true,
      handler() {
        if (this.options.typeUpload == "Start") {
          let id = this.options.id;
          this.array.push({
            message: "กำลังอัปโหลด",
            type: this.options.type,
            progress: 0,
            id: id,
          });
          this.SetProgress(id);
        } else if (this.options.typeUpload == "End") {
          clearInterval(this.options.id);
          this.array.forEach((element) => {
            if (element.id == this.options.id) {
              element.message = this.options.message;
              element.type = this.options.type;
            }
          });
          this.StartTimer(this.options.id);
        } else if (this.options.message) {
          let id = this.setIdNoti(this.options.date);
          this.array.push({
            message: this.options.message,
            type: this.options.type,
            name: this.typeName(this.options.type),
            id: id,
          });

          this.StartTimer(id);
        }
      },
    },
  },
  methods: {
    SetProgress(id) {
      let _this = this;
      let progress = 0;
      id = setInterval(frame, 27); // 0 - 95 ใน 2.5 วินาที
      function frame() {
        if (progress >= 95) {
          clearInterval(id);
        } else {
          progress++;
          _this.array.forEach((element) => {
            if (element.id === _this.options.id) {
              element.progress = progress;
            }
          });
        }
      }
    },
    setIdNoti(date) {
      return `${date.getDay()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}${date.getMilliseconds()}`;
    },
    typeName(type) {
      switch (type) {
        case Enums.TypeComponentNoti.success:
          return "สำเร็จ";
          break;
        case Enums.TypeComponentNoti.warn:
          return "แจ้งเตือน";
          break;
        case Enums.TypeComponentNoti.error:
          return "ผิดพลาด";
          break;
      }
    },

    remove(id) {
      this.array.forEach((item, index) => {
        if (id == item.id) {
          this.array.splice(index, 1);
        }
      });

      delete this.timer[id];
    },
    StopTimer(id) {
      clearTimeout(this.timer[id]);
      delete this.timer[id];
    },
    StartTimer(id) {
      this.timer[id] = setTimeout(() => {
        this.remove(id);
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
#noti {
  position: fixed;
  bottom: 40px;
  left: 10px;
  z-index: 999;
  .notiBox {
    div.box {
      margin-top: 10px;
      position: relative;
      display: flex;
      // align-items: center;
      padding: 10px 30px 10px 20px;
      border-radius: 6px;
      min-width: 200px;
      max-width: 380px;
      @include shadowboxLv2;
      transition: 0.5s;
      img {
        border-radius: 50%;
        margin-right: 20px;
      }
      i.close {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 10px;
        cursor: pointer;
      }
      i.alertNoti {
        font-size: 25px;
        margin-right: 20px;
      }
      h3,
      p,
      i.close {
        color: $text;
      }
    }
    .success {
      background: $bgGreen;
      i.alertNoti {
        color: $green;
      }
    }
    .warn {
      background: $bgOrange;
      i.alertNoti {
        color: #ff9e40;
      }
    }
    .error {
      background: $bgRed;
      i.alertNoti {
        color: $alert;
      }
    }
    .upload {
      background: #eff8ff;
      align-items: center;
    }
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 1s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translatex(-350px);
  }
  .text-break {
    word-break: break-word;
  }
}
</style>
